import React from 'react';
import Parser from 'html-react-parser';
import { Link } from 'react-router';

import './ProcedureDesc.scss';

class ProcedureDesc extends React.PureComponent {

  render() {
    const procedure = this.props.procedure;
    return (
      <section className="procedureDesc">
        <div className="container relative">
          <Link
            to={{
              pathname: '/zakroky',
              state: {surgeryId: this.props.surgeryId}
            }}
            className="backwardsBtn"
          >
            <i className="llc-keyboard-right-arrow-button"/>
          </Link>
          <div className="procedureDesc_title">{procedure.name}</div>
          <div className="procedureDesc_content">
            {Parser(procedure.text)}
          </div>
        </div>
      </section>
    );
  }
}

export default ProcedureDesc;



// WEBPACK FOOTER //
// ./src/components/Procedure/ProcedureDesc/ProcedureDesc.js